














import Vue from "vue";
import SmallTable, { Header } from "@/components/ui/SmallTable.vue";
import { Element, Rolle } from "@/types";
import { erklServiceInstance } from "@/services/ErklService";
import { alertError } from "@/services/ErrorAlert";
import { Ansprechpartner } from "@/types/Ansprechpartner";

/**
 * @Emits open if an element opens
 * @Emits close if an element closes
 */
export default Vue.extend({
  name: "ContactTable",
  components: {
    SmallTable,
  },
  props: {
    /** array of elements for each field */
    contacts: {
      type: Array as () => Array<any>,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Ansprechpartner",
    },
  },
  data: function () {
    return {
      rollen: [] as Rolle[],
      namen: [] as Element[],
      institutionen: [] as Element[],
      contactReadonly: true,
    };
  },
  mounted() {
    Promise.all([
      erklServiceInstance
        .getRollen()
        .then((data: Rolle[]) => (this.rollen = data)),

      erklServiceInstance
        .getInstitutionOptions()
        .then((data: Element[]) => (this.institutionen = data)),
    ])
      .then()
      .catch((error: any) => alertError(error))
      .finally();
  },
  methods: {
    loadNamen(id: any, ext: number) {
      if (ext !== undefined)
        erklServiceInstance
          .getAnsprechpartner(id, ext)
          .then((data: Element[]) => {
            this.namen = data;
            //this.$emit("resetContact");
          });
    },

    onChangeAnsprechpartner(value: any, row: Ansprechpartner) {
      if (value === null || value === undefined) {
        return;
      }
      this.contactReadonly = true;
      if (value.length == 0) {
        this.$emit("removeAnsprechpartner", row);
        if (row.institutionen.length)
          this.loadNamen(row.institutionen[0].id, row.institutionen[0].ext);
      }
      if (value.length > 0 && value[0].id !== row.ansprechpartnerId) {
        erklServiceInstance
          .loadAnsprechpartner(value.length ? value[0].id : -1)
          .then((data: Ansprechpartner) => {
            data.id = row.id;
            this.$emit("loadAnsprechpartner", data);
          });
      }
      if (value.length > 0 && value[0].id === "") {
        this.contactReadonly = false;
      }
    },
    onChangeInstitution(value: any, row: Ansprechpartner) {
      if (value.length == 0) {
        this.namen = [];
        this.$emit("resetAnsprechpartner", row);
      }
      if (
        value.length > 0 &&
        (value[0].id !== row.checkId || row.namen.length == 0)
      ) {
        this.loadNamen(value[0].id, value[0].ext);
        this.$emit("resetAnsprechpartner", row);
      }
    },
  },
  computed: {
    tableContactsHeader(): Header[] {
      return [
        {
          field: "institutionen",
          label: "Institution *",
          display: function (v, r) {
            let result = "";
            if (r.institutionen !== null && r.institutionen.length > 0) {
              result += r.institutionen[0].bez;
            }
            return result;
          },
          onChange: (value, row) => {
            this.onChangeInstitution(value, row);
          },
          type: "multiselect",
          options: this.institutionen,
          sortable: true,
          addable: true,
        },

        {
          field: "namen",
          label: "Name *",
          display: function (v, r) {
            let result = "";
            if (r.namen !== null && r.namen.length > 0) {
              result += r.namen[0].bez;
            }
            return result;
          },
          onChange: (value, row) => {
            this.onChangeAnsprechpartner(value, row);
          },
          type: "multiselect",
          options: this.namen,
          sortable: true,
          addable: true,
        },
        {
          field: "rollen",
          label: "Rolle *",
          display: function (v, r) {
            let result = "";
            if (r.rollen !== null && r.rollen.length > 0) {
              result += r.rollen[0].bez;
            }
            return result;
          },
          type: "multiselect",
          options: this.rollen,
          sortable: true,
          addable: true,
          disabled: this.contactReadonly,
        },
        {
          field: "telefon",
          label: "Telefon",
          sortable: true,
          disabled: this.contactReadonly,
        },
        {
          field: "email",
          label: "E-Mail",
          type: "email",
          sortable: true,
          required: false,
          disabled: this.contactReadonly,
        },
        {
          field: "bemerkung",
          label: "Bemerkung",
          sortable: true,
          disabled: this.contactReadonly,
        },
      ] as Header[];
    },
    newAnsprechpartner(): Ansprechpartner {
      let item = {} as Ansprechpartner;
      item.institutionen = [];
      item.namen = [];
      item.rollen = [];
      return item;
    },
  },
});
